import { ASSETS, SUPPORT_EMAIL } from "@/constants/assets";
import { useT } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useT();
  return (
    <footer className="bg-[#0B1726] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="logo-badge">
              <img src={ASSETS.logo} alt="Institut PROSPECT'HEURE" className="h-10 w-10 object-contain" />
            </div>
            <div className="font-semibold text-[15px] tracking-tight">Institut PROSPECT&rsquo;HEURE</div>
          </div>
          <p className="text-[14px] text-[#C4CBD7] leading-relaxed max-w-xs">{t("footer.baseline")}</p>
        </div>

        <div>
          <div className="text-[#C9A45C] text-[11px] font-semibold tracking-[0.22em] uppercase mb-4">{t("footer.contact")}</div>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="block text-[14px] text-white hover:text-[#E8D2A1] transition-colors"
            data-testid="footer-support-email"
          >
            {SUPPORT_EMAIL}
          </a>
          <div className="text-[13px] text-[#98A2B3] mt-2">{t("footer.support_hours")}</div>
        </div>

        <div>
          <div className="text-[#C9A45C] text-[11px] font-semibold tracking-[0.22em] uppercase mb-4">{t("footer.navigation")}</div>
          <ul className="space-y-2 text-[14px] text-white">
            <li><a href="#livre" className="hover:text-[#E8D2A1] transition-colors">{t("nav.guide")}</a></li>
            <li><a href="#conferences" className="hover:text-[#E8D2A1] transition-colors">{t("nav.conferences")}</a></li>
            <li><a href="#entrainement" className="hover:text-[#E8D2A1] transition-colors">{t("nav.training")}</a></li>
            <li><a href="#entraineur" className="hover:text-[#E8D2A1] transition-colors">{t("nav.coach")}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#16263A]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-[12px] text-[#98A2B3]">
            © {new Date().getFullYear()} Institut PROSPECT&rsquo;HEURE — {t("footer.rights")}
          </div>
          <div className="text-[12px] text-[#98A2B3]">
            {t("footer.powered")} <span className="text-[#C9A45C] font-semibold">PROFITHÈQUE MONDE</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
